import { FilterTable } from "@/features/FilterTable/FilterTable";
import { Field } from "@/features/FilterTable/types";
import {
  dateSchema,
  parseToDateValue,
  preprocessTextAsyncAutocompleteField,
} from "@/features/FormCard/utils";
import { z } from "zod";

// Enum options extracted from Ruby code with string values
export const factorTypeOptions = [
  { value: "0", label: "Market" },
  { value: "1", label: "Low Beta" },
  { value: "2", label: "Size" },
  { value: "3", label: "Value" },
  { value: "4", label: "Momentum" },
  { value: "5", label: "Quality" },
  { value: "6", label: "Risk Free" },
  { value: "7", label: "Alpha" },
  { value: "8", label: "Equity" },
  { value: "9", label: "Sovereign" },
  { value: "10", label: "Investment Grade" },
  { value: "11", label: "High Yield" },
  { value: "12", label: "Mortgage" },
  { value: "13", label: "Gold" },
  { value: "14", label: "Oil" },
];

export const filterFactorsSchema = z.object({
  group_name_contains: z
    .preprocess(preprocessTextAsyncAutocompleteField, z.string())
    .optional(),
  factor_type_contains: z.string().nullable().optional(),
  tag_id: z
    .preprocess(preprocessTextAsyncAutocompleteField, z.string())
    .optional(),
  created_at_from: z
    .preprocess((val) => parseToDateValue(val as string), dateSchema)
    .optional(),
  created_at_to: z
    .preprocess((val) => parseToDateValue(val as string), dateSchema)
    .optional(),
});

export type FilterFactorsSchema = z.infer<typeof filterFactorsSchema>;

export const fields: Field[] = [
  {
    name: "group_name_contains",
    label: "Group Name",
    type: "asyncAutocomplete",
    base_url: "legacy-quantilia/factors",
    column_name: "group_name",
  },
  {
    name: "factor_type_contains",
    label: "Factor Type",
    type: "select",
    useTranslation: false,
    options: factorTypeOptions,
  },
  {
    name: "tag_id",
    label: "Tag",
    type: "asyncAutocomplete",
    base_url: "legacy-quantilia/tags",
    column_name: "name",
    id_column: "id",
  },
  {
    name: "created_at_from",
    label: "Created From",
    type: "date",
  },
  {
    name: "created_at_to",
    label: "Created To",
    type: "date",
  },
];

export const client = "legacy-quantilia";

export function FilterFactors() {
  return (
    <FilterTable
      client={client}
      schema={filterFactorsSchema}
      tableName="factors"
      customBuildPath={() => `${client}/factors`}
      fields={fields}
    />
  );
}
